export const discoverDealsFaqs = [
  {
    question: "What is AngelList India's Investment Structure?",
    answer: (
      <div>
        <p>
          AngelList India is a SEBI-registered Angel Fund, a sub-category of VCF under Category-I
          AIF.
        </p>
        <p className="mt-2">Key characteristics include:</p>
        <ul className="list-disc pl-5 mt-2">
          <li>A separate special-purpose vehicle (SPV) is created for each startup investment</li>
          <li>
            Investors receive <strong>'units'</strong> instead of direct company shares
          </li>
          <li>Investors invest through AngelList India's platform</li>
        </ul>
        <p className="mt-2">
          Unit Statements depicting portfolio company valuations are shared biannually (September
          and March).
        </p>
      </div>
    ),
  },
  {
    question: 'How can an investor discover or participate in deals on AngelList India’s platform?',
    answer: (
      <div>
        <p>
          By default, deals on AngelList India are private and only visible to the investors invited
          by Syndicate Leads or Founders (in the case of a Roll Up Vehicle). Here’s how it works:
        </p>
        <ul className="list-disc pl-5 mt-2">
          <li>Leads/Founders can invite investors from their dashboard.</li>
          <li>
            Eligible angel investors outside the AngelList India investor network can join via a
            private deal invite link.
          </li>
          <li>
            Leads/Founders usually close deals through their investor networks. If additional
            allocation remains, and if the Leads/Founders want to invite capital from outside of
            their investor networks, AngelList India may review and share the deal on a deal-by-deal
            basis.
          </li>
        </ul>
      </div>
    ),
  },
  {
    question: 'Can a Deal be Shared Publicly?',
    answer: (
      <div>
        <p>
          Sharing deals publicly is not permitted. The Lead/Founder or any participating/prospective
          investor cannot share deals on public platforms such as:
        </p>
        <ul className="list-disc pl-5 mt-2">
          <li>Twitter</li>
          <li>LinkedIn</li>
          <li>Newsletters</li>
          <li>Blogs</li>
        </ul>
      </div>
    ),
  },
  {
    question: 'What is the Minimum Amount to be Invested per Deal?',
    answer: (
      <div>
        <ul className="list-disc pl-5">
          <li>Domestic Indian bank accounts: INR 3 Lakhs per commitment</li>
          <li>NRO/NRE Accounts: Minimum investment of INR 10 Lakhs per commitment</li>
        </ul>
      </div>
    ),
  },
  {
    question: 'What is the Minimum Amount to be Invested by Investors Through AngelList India?',
    answer: (
      <div>
        <p>As per SEBI guidelines, investors must meet the following investment threshold:</p>
        <ul className="list-disc pl-5 mt-2">
          <li>Minimum of INR 25 Lakhs over 5 years from first investment</li>
          <li>Can be invested in a single deal or multiple deals</li>
        </ul>
        <p className="mt-2">
          Recommendation: Make multiple investments to diversify startup investment risks.
        </p>
      </div>
    ),
  },
  {
    question: 'Which bank account can be used to wire the funds?',
    answer: (
      <div>
        <p>
          Investors must use bank accounts linked to their demat accounts. The bank account name
          must match the investment entity used for the deal commitment.
        </p>
      </div>
    ),
  },
  {
    question: 'When are Investors Required to Wire Their Investment Amount?',
    answer: (
      <div>
        <p>Funds are wired only after:</p>
        <ul className="list-disc pl-5 mt-2">
          <li>all investors in the scheme have committed</li>
          <li>Lead or Founder decides to close the scheme</li>
          <li>target allocation has been filled</li>
        </ul>
        <p className="mt-2">
          AngelList India will send a <strong>"AL Trust - Drawdown Notice"</strong> email that:
        </p>
        <ul className="list-disc pl-5 mt-2">
          <li>confirms final investment amount</li>
          <li>provides wiring instructions</li>
        </ul>
      </div>
    ),
  },
  {
    question: 'How much does an Investor have to wire?',
    answer: (
      <div>
        <p>Investors must wire their committed investment amount plus a 2.5% setup fee. Details:</p>
        <ul className="list-disc pl-5 mt-2">
          <li>
            For example, a commitment of INR 3 Lacs will require a transfer of INR 3.075 Lacs (INR 3
            Lacs + 2.5% setup fee of INR 7,500).
          </li>
          <li>RUVs are 0% carry vehicles, but investors must pay carry fees on Syndicate deals.</li>
        </ul>
      </div>
    ),
  },
  {
    question: 'How do Investors wire their investment amount?',
    answer: (
      <div>
        <p>Investors can wire their investment amount using NEFT or RTGS. Important points:</p>
        <ul className="list-disc pl-5 mt-2">
          <li>Wire instructions are provided in the Drawdown Notice.</li>
          <li>Cheque payments are not accepted.</li>
        </ul>
      </div>
    ),
  },
  {
    question: 'Are Investors party to the investment documents of the investee company?',
    answer: (
      <div>
        <p>
          Investors in the scheme are not party to the investee company's investment documents (such
          as SSA, SHA, or Convertible Note Agreement). Instead:
        </p>
        <ul className="list-disc pl-5 mt-2">
          <li>
            Investors subscribe to the scheme via a contribution agreement with AL Trust and
            AngelList India.
          </li>
          <li>
            AngelList India (the official signatory) reviews investment documents to ensure
            alignment with the terms described to investors before signing.
          </li>
          <li>
            If there is a divergence in terms, the Founder/Lead must post an update to investors and
            offer an opportunity to opt-out (or in some cases, explicitly opt-in).
          </li>
        </ul>
      </div>
    ),
  },
  {
    question: 'Do all Investors invest on homogeneous terms?',
    answer: (
      <div>
        <p>
          Yes, all investors in the scheme invest on the same round terms as other investors in the
          scheme.
        </p>
      </div>
    ),
  },
  {
    question:
      "What are the Tax Implications of Investing Through AngelList India's SEBI-regulated 'Angel Fund'?",
    answer: (
      <div>
        <p>
          When investing, the investor becomes part of AngelList India, registered with SEBI as an
          Angel Fund under the SEBI AIF Regulations, 2012.
        </p>
        <ul className="list-disc pl-5 mt-2">
          <li>Angel Funds have pass-through status for all incomes (except business income)</li>
          <li>
            Investors are taxed in the same manner and proportion as direct portfolio company
            investments
          </li>
          <li>10% withholding applied for resident investors</li>
          <li>Non-resident investors taxed at prevailing rates</li>
          <li>Investors can claim tax credit when filing returns</li>
        </ul>
        <p className="mt-2 italic text-sm">
          Important Note: AngelList India is not qualified to provide tax advice. Many exceptions
          exist to these general provisions. Investors should consult their own counsel, accountant,
          or investment advisor regarding legal and tax matters.
        </p>
      </div>
    ),
  },
];
